<template>
    <div>
        <fullscreen-loading v-if="loading" />

        <div class="row mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-3">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <span class="h4">{{ $t('ceremony.title') }}</span>
                            </div>
                            <div class="text-right">
                                <div class="actions mr-n2">
                                    <div class="float-right" @click="createCeremony" style="cursor: pointer;">
                                        <button class="btn btn-secondary btn-sm rounded-circle btn-icon-only float-right">
                                            <icon name="plus"></icon>
                                        </button>
                                        <h2 class="h6 mt-2 mr-2 float-right">{{ $t('ceremony.new_ceremony_or_condoleance') }}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <table class="table table-sm table-no-side-paddings table-striped">
                            <thead>
                                <tr>
                                    <ordering @change="load()" v-model="order" field="name" tag="th">
                                        {{ $t('ceremony.deceased_name') }}
                                    </ordering>
                                    <ordering @change="load()" v-model="order" field="code" tag="th">
                                        {{ $t('ceremony.code') }}
                                    </ordering>
                                    <ordering @change="load()" v-model="order" field="date" tag="th">
                                        {{ $t('ceremony.date') }}
                                    </ordering>
                                    <th>{{ $t('ceremony.duration_in_minutes') }}</th>
                                    <ordering @change="load()" v-model="order" field="duration" tag="th">
                                        {{ $t('ceremony.max_duration') }}
                                    </ordering>
                                    <ordering @change="load()" v-model="order" field="location_id" tag="th">
                                        {{ $t('ceremony.location') }}
                                    </ordering>
                                    <th>{{ $t('ceremony.mail') }}</th>
                                    <ordering @change="load()" v-model="order" field="state_id" tag="th">
                                        {{ $t('ceremony.status') }}
                                    </ordering>
                                    <th>{{ $t('ceremony.user') }}</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <input :placeholder="$t('ceremony.deceased_name')" @change="load(1)"
                                               class="form-control form-control-filtering" type="text" v-model="filtering.name" />
                                    </td>
                                    <td>
                                        <input :placeholder="$t('ceremony.code')" @change="load(1)"
                                               class="form-control form-control-filtering" type="text" v-model="filtering.code" />
                                    </td>
                                    <td>
                                        <datetime-picker v-model="filtering.date" :placeholder="$t('ceremony.date')" type="date"
                                                         inputClass="form-control form-control-filtering" class="theme-company"
                                                         :format="'dd-MM-yyyy'" @input="load(1)" />
                                    </td>
                                    <td />
                                    <td>
                                        <minute-input @change="load(1)" :placeholder="$t('ceremony.duration')"
                                                      class="form-control form-control-filtering" v-model="filtering.duration">
                                        </minute-input>
                                    </td>
                                    <td>
                                        <select @change="load(1)" class="form-control form-control-filtering" v-model="filtering.location_id">
                                            <option :value="null">{{ $t('general.select_option') }}</option>
                                            <option :value="location.id" v-for="location of locations">{{ location.name }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select @change="load(1)" class="form-control form-control-filtering"
                                                v-model="filtering.email_log_sparkpost_state">
                                            <option :value="null">{{ $t('general.select_option') }}</option>
                                            <option :value="1">{{ $t('ceremony.mail_sent') }}</option>
                                            <option :value="3">{{ $t('ceremony.mail_delivered') }}</option>
                                            <option :value="4">{{ $t('ceremony.mail_bounced') }}</option>
                                            <option :value="5">{{ $t('ceremony.mail_out_of_bound') }}</option>
                                            <option :value="6">{{ $t('ceremony.mail_delayed') }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select @change="load(1)" class="form-control form-control-filtering" v-model="filtering.state_id">
                                            <option :value="null">{{ $t('general.select_option') }}</option>
                                            <option :value="'relevant'">{{ $t('ceremony.relevant') }}</option>
                                            <option :value="state.id" v-for="state of states">{{ $t('ceremony.state_' + state.state.capitalize()) }}</option>
                                            <option :value="'cleaned_up'">{{ $t('ceremony.cleaned_up') }}</option>
                                            <option :value="'unknown_date'">{{ $t('ceremony.unknown_date') }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select @change="load(1)" class="form-control form-control-filtering" v-model="filtering.user_id">
                                            <option :value="null">{{ $t('general.select_option') }}</option>
                                            <option :value="user.id" v-for="user of users">{{ user.name }}</option>
                                        </select>
                                    </td>
                                    <td />
                                </tr>
                                <tr v-for="ceremony of ceremonies.data">
                                    <td>
                                        {{ ceremony.name }} {{ ceremony.attendees.length && ceremony.attendees[0].name ? ` - ${ceremony.attendees[0].name}` : '' }}
                                        <div v-if="ceremony.livestream_event_id" style="margin-top: -10px">
                                            <CeremonyLivestreamLink :ceremony="ceremony" />
                                        </div>
                                    </td>
                                    <td>
                                        {{ ceremony.code }}
                                        <small style="font-size: 10px; display: block; margin-top: -5px;">
                                            {{ ceremony.translated_type }}
                                        </small>
                                    </td>
                                    <td>
                                    <span class="badge badge-info" v-if="ceremony.date_unknown">
                                        {{ $t('ceremony.unknown_date') }}
                                    </span>
                                        <span v-else>{{ formatDateTime(ceremony.date) }}</span>
                                    </td>
                                    <td>{{ ceremony && ceremony.type !== 'condolence' ? $root.minutesToTimeInput(ceremony.total_duration) : '-' }}</td>
                                    <td>{{ ceremony && ceremony.type !== 'condolence' ? $root.minutesToTimeInput(ceremony.duration) : '-' }}</td>
                                    <td>{{ ceremony.location.name }}</td>
                                    <td>
                                        <div v-if="ceremony.email_logs.length >= 1">
                                        <span class="badge badge-info" v-if="ceremony.email_logs[0].sparkpost_state === 1">
                                            {{ $t('ceremony.mail_sent') }}
                                        </span>
                                            <span class="badge badge-success" v-else-if="ceremony.email_logs[0].sparkpost_state === 3">
                                            {{ $t('ceremony.mail_delivered') }}
                                        </span>
                                            <span class="badge badge-danger" v-else-if="ceremony.email_logs[0].sparkpost_state === 4">
                                            {{ $t('ceremony.mail_bounced') }}
                                        </span>
                                            <span class="badge badge-danger" v-else-if="ceremony.email_logs[0].sparkpost_state === 5">
                                            {{ $t('ceremony.mail_out_of_bound') }}
                                        </span>
                                            <span class="badge badge-warning" v-else-if="ceremony.email_logs[0].sparkpost_state === 6">
                                            {{ $t('ceremony.mail_delayed') }}
                                        </span>
                                        </div>
                                    </td>
                                    <td>
                                <span class="badge" :class="getStateBadgeClass(ceremony)"
                                      v-tooltip="getStateTooltip(ceremony)">
                                    {{ getStateText(ceremony) }}
                                </span>
                                        <td>
                                            {{ ceremony?.user?.name ?? '-' }}
                                        </td>
                                        <td class="text-right">
                                            <download-ceremony v-if="!ceremony.cleaned_up_at && ceremony.state_id !== 1"
                                                               :tooltip="$t('ceremony.download_tooltip')"
                                                               :ceremony="ceremony"
                                                               :with-text="false" />
                                            <button class="btn btn-xs rounded-pill btn-danger" @click="toggleDeleteCeremonyModal(ceremony)"
                                                    :v-tooltip="$t('general.delete')" v-if="(hasPermission('deleteOwnCeremonies') && ceremony.user_id === user.id) || hasPermission('deleteCeremonies')">
                                                <icon name="trash" scale="0.8"></icon>
                                            </button>
                                            <button class="btn btn-xs rounded-pill btn-primary" @click="editCeremony(ceremony)"
                                                    :v-tooltip="$t('general.edit')" v-if="!ceremony.cleaned_up_at">
                                                <icon name="pencil-alt" scale="0.8"></icon>
                                            </button>
                                            <button class="btn btn-xs rounded-pill btn-dark" @click="toggleSendInvitesModal(ceremony)"
                                                    :v-tooltip="$t('ceremony.send_invite')" v-if="canSendInvite(ceremony)">
                                                <icon name="envelope" scale="0.8"></icon>
                                            </button>
                                            <button class="btn btn-xs rounded-pill btn-info" @click="toggleSendInviteDownloadsModal(ceremony)"
                                                    :v-tooltip="$t('ceremony.send_invite_download')" v-if="canSendInviteDownload(ceremony)">
                                                <icon name="envelope" scale="0.8"></icon>
                                            </button>
                                            <router-link class="btn btn-xs rounded-pill btn-info"
                                                         :v-tooltip="$t('ceremony.design')" :to="'/code/' + ceremony.code"
                                                         v-if="!ceremony.cleaned_up_at">
                                                <icon name="swatchbook" scale="0.8"></icon>
                                            </router-link>
                                        </td>
                                </tr>
                                <tr v-if="ceremonies.data.length === 0 && !loading">
                                    <td colspan="100%" class="no-results">
                                        {{ $t('ceremony.no_ceremonies_found') }}

                                        <div class="text-center">
                                            <button @click="createCeremony" class="btn btn-primary btn-xs ml-5">
                                                {{ $t('ceremony.new_ceremony_or_condoleance') }}
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-footer border-0">
                        <Pagination :pagination="ceremonies" @change="load"/>
                    </div>
                </div>
            </div>
        </div>

        <modal :show="ceremony_to_delete" :closable="!loading" @close="ceremony_to_delete = null">
            <div slot="header">
                <div class="modal-header" v-if="ceremony_to_delete">
                    <h5 class="modal-title">
                        {{ ceremony_to_delete.translated_type }} {{ $t('ceremony.delete_title') }}
                    </h5>
                    <button type="button" class="close" @click="ceremony_to_delete = null" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
            </div>

            <div slot="body" v-if="ceremony_to_delete">
                {{
                    $t('ceremony.delete_message', {
                        type: ceremony_to_delete.translated_type.toLowerCase(),
                        name: ceremony_to_delete.name,
                    })
                }}
            </div>

            <div slot="footer">
                <button type="button" class="btn btn-danger btn-icon btn-sm" @click="deleteCeremony()">
                    <icon name="trash" scale="0.8"></icon>
                    {{ $t('general.delete') }}
                </button>
                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"
                        @click="ceremony_to_delete = null">
                    {{ $t('general.close') }}
                </button>
            </div>
        </modal>

        <modal :show="ceremony_to_send_invites" :closable="!loading" @close="ceremony_to_send_invites = null">
            <div slot="header">
                <div class="modal-header" v-if="ceremony_to_send_invites">
                    <h5 class="modal-title">{{ $t('ceremony.send_invitation_title') }}</h5>
                    <button type="button" class="close" @click="ceremony_to_send_invites = null" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
            </div>

            <div slot="body" v-if="ceremony_to_send_invites">
                {{
                    $t('ceremony.send_invitation_message', {
                        type: ceremony_to_send_invites.translated_type.toLowerCase(),
                        name: ceremony_to_send_invites.name,
                        emails: getCeremonyAttendeeEmails(ceremony_to_send_invites).join(', '),
                    })
                }}
            </div>

            <div slot="footer">
                <button type="button" class="btn btn-success btn-icon btn-sm" @click="sendInvites()">
                    <icon name="envelope" scale="0.8"></icon>
                    {{ $t('general.send') }}
                </button>
                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"
                        @click="ceremony_to_send_invites = null">
                    {{ $t('general.close') }}
                </button>
            </div>
        </modal>

        <modal :show="ceremony_to_send_invite_downloads" :closable="!loading"
               @close="ceremony_to_send_invite_downloads = null">
            <div slot="header">
                <div class="modal-header" v-if="ceremony_to_send_invite_downloads">
                    <h5 class="modal-title">{{ $t('ceremony.send_invitation_download_title') }}</h5>
                    <button type="button" class="close" @click="ceremony_to_send_invite_downloads = null" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
            </div>

            <div slot="body" v-if="ceremony_to_send_invite_downloads">
                {{
                    $t('ceremony.send_invitation_download_message', {
                        type: ceremony_to_send_invite_downloads.translated_type.toLowerCase(),
                        name: ceremony_to_send_invite_downloads.name,
                        emails: getCeremonyAttendeeEmails(ceremony_to_send_invite_downloads).join(', '),
                    })
                }}
            </div>

            <div slot="footer">
                <button type="button" class="btn btn-success btn-icon btn-sm" @click="sendInvitesDownload()">
                    <icon name="envelope" scale="0.8"></icon>
                    {{ $t('general.send') }}
                </button>
                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"
                        @click="ceremony_to_send_invite_downloads = null">
                    {{ $t('general.close') }}
                </button>
            </div>
        </modal>

        <modal :show="ceremonyData" :closable="!loading" @close="ceremonyData = null; ceremonyToEdit = null;" custom_dialog_css="max-width: 600px;">
            <div slot="header">
                <div class="modal-header" v-if="ceremonyData">
                    <h5 v-if="ceremonyData.id === null" class="modal-title">
                        {{ $t('ceremony.new_ceremony_type', { type: ceremonyDataTranslatedType.toLowerCase() }) }}
                    </h5>
                    <h5 v-else class="modal-title">
                        {{ $t('ceremony.edit_ceremony', { type: ceremonyDataTranslatedType }) }}
                    </h5>
                    <button type="button" class="close" @click="ceremonyData = null" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
            </div>

            <div slot="body" v-if="ceremonyData">
                <div class="alert alert-warning" v-if="ceremonyData.created_by === 'api'">
                    {{ $t('ceremony.api_created_warning', { type: ceremonyDataTranslatedType.toLowerCase() }) }}
                </div>

                <div class="alert alert-warning" v-if="canSync">
                    {{ $t('ceremony.last_minute_sync_warning') }}
                </div>

                <div v-if="ceremonyData.external_service_logs && ceremonyData.external_service_logs.length">
                    <div class="alert alert-danger" v-for="exception of ceremonyData.external_service_logs">
                        <div>
                            <strong>{{ exception.type }}</strong>
                        </div>
                        {{ exception.message }}
                    </div>
                </div>

                <CeremonyForm
                    v-model="ceremonyData"
                    :ceremony="ceremonyToEdit"
                    :disabled="loading"
                    :errors="ceremonyErrors"
                />
            </div>

            <div slot="footer" v-if="ceremonyData" class="d-flex w-100">
                <a class="btn btn-sm btn-icon btn-light"
                   :v-tooltip="$t('ceremony.download_zip_tooltip')"
                   :download="ceremonyData.translated_type + ' - ' + ceremonyData.code"
                   :href="'/api/ceremonies/' + ceremonyData.id + '/download?token=' + token + '&version=' + version"
                   v-if="!ceremonyData.cleaned_up_at && hasPermission('downloadCeremony') && !syncFrom && ceremonyData.state_id !== 1">
                    <icon name="download" scale="0.8" />
                </a>

                <button type="button" class="btn btn-primary btn-sm ml-auto" @click="saveCeremony" :disabled="loading">
                    {{ $t('general.save') }}
                </button>
                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"
                        @click="ceremonyData = null; ceremonyToEdit = null;" :disabled="loading">
                    {{ $t('general.close') }}
                </button>
            </div>
        </modal>
    </div>
</template>

<script>

    import FullscreenLoading from '../../components/FullscreenLoading';
    import Pagination from '../../components/Pagination';
    import Ordering from '../../components/Ordering';
    import Modal from '../../components/Modal';
    import FormErrors from '../../components/FormErrors';
    import { mapGetters, mapState } from 'vuex';
    import filteringFromObject from '../../utils/filteringFromObject';
    import MinuteInput from '../../components/MinuteInput';
    import UtilMixin from '../mixins/UtilMixin';
    import DatetimePicker from '../../components/DatetimePicker';
    import moment from 'moment';
    import DownloadCeremony from './DownloadCeremony.vue';
    import CeremonyForm from '../../components/CeremonyForm.vue';
    import CeremonyLivestreamLink from '../../components/CeremonyLivestreamLink.vue';

    export default {

        components: {
            CeremonyLivestreamLink,
            CeremonyForm,
            DownloadCeremony,
            Pagination,
            Ordering,
            FullscreenLoading,
            Modal,
            FormErrors,
            MinuteInput,
            DatetimePicker,
        },

        mixins: [
            UtilMixin,
        ],

        data() {
            return {
                loading: false,
                ceremonies: {
                    current_page: 1,
                    data: [],
                },
                users: [],

                order: 'date,desc',
                filtering: {
                    name: null,
                    code: null,
                    date: null,
                    duration: null,
                    location_id: null,
                    email_log_sparkpost_state: null,
                    state_id: 'relevant',
                    user_id: null,
                },

                ceremonyData: null,
                ceremonyToEdit: null,
                ceremony_to_delete: null,
                ceremony_to_send_invites: null,
                ceremony_to_send_invite_downloads: null,
                ceremonyErrors: null,

                version: APP_VERSION,
                syncFrom: window.SYNC_FROM,
            };
        },

        computed: {
            ceremonyDataTranslatedType() {
                if (!this.ceremonyData) {
                    return '';
                }

                switch (this.ceremonyData.type) {
                    case 'ceremony':
                        return this.$t('ceremony.type_ceremony');
                    case 'condolence':
                        return this.$t('ceremony.type_condolence');
                    case 'ledwall':
                        return this.$t('ceremony.type_ledwall');
                }

                return this.$t('ceremony.type_unknown');
            },

            canSync() {
                return Boolean(window.SYNC_FROM);
            },

            ...mapState({
                locations: state => state.locations,
                states: state => state.states,
                token: state => state.token,
                user: state => state.user,
                companySettings: state => state.companySettings,
            }),

            ...mapGetters([
                'hasPermission',
            ]),
        },

        watch: {
            'companySettings.default_location_id'() {
                this.filtering.location_id = window.SYNC_FROM ? this.companySettings.default_location_id : '';
            },
        },

        async created() {
            this.ceremonies.current_page = 1;
            await this.getAllCeremonyUsers();
            await this.load();
        },

        mounted() {
            this.filtering.location_id = window.SYNC_FROM ? this.companySettings.default_location_id : '';

            if (window.location.hash === '#create') {
                this.createCeremony();
            }
        },

        methods: {
            async load(page = undefined) {
                this.loading = true;

                try {
                    const response = await this.$http.get('/api/ceremonies', {
                        params: {
                            page: page || this.ceremonies.current_page,
                            order: this.order,
                            filters: filteringFromObject(this.filtering, {
                                date: 'date',
                            }),
                        },
                    });

                    this.ceremonies = response.data;
                } catch (exception) {
                    if (!exception.response || (exception.response && exception.response.status !== 401)) {
                        alert('Failed to load ceremonies');
                    }
                }

                this.loading = false;
            },

            async getAllCeremonyUsers() {
                this.loading = true;

                try {
                    const response = await this.$http.get('/api/ceremonies/users/all');
                    this.users = response.data;

                    // Set the filter to the current user
                    if (this.filtering.user_id === null) {
                        this.filtering.user_id = this.user?.id ?? null;
                    }
                } catch (exception) {
                    if (!exception.response || (exception.response && exception.response.status)) {
                        alert('Failed to load users');
                    }
                } finally {
                    this.loading = false;
                }
            },

            async saveCeremony() {
                this.loading = true;

                try {
                    // if the date is unknown then set the date plus 100 so that the validation of the backend passes.
                    if (this.ceremonyData.date_unknown) {
                        let date = new Date();
                        date.setFullYear(date.getFullYear() + 100);
                        this.ceremonyData.date = date.toISOString().split('T')[0];
                    }
                    const response = await this.$http[this.ceremonyData.id ? 'put' : 'post'](`/api/ceremonies${this.ceremonyData.id ? `/${this.ceremonyData.id}` : ''}`, this.ceremonyData);
                    await this.load();

                    if ((response?.data?.external_service_logs || []).length) {
                        this.ceremonyData = response.data;
                    } else {
                        this.ceremonyData = null;
                    }
                } catch (exception) {
                    if (exception.response && exception.response.status === 422) {
                        this.ceremonyErrors = exception.response.data.errors;
                    } else {
                        if (!exception.response || (exception.response && exception.response.status !== 401)) {
                            alert('Cannot save ceremony');
                        }
                    }
                }

                this.loading = false;
            },


            async deleteCeremony() {
                this.loading = true;

                try {
                    await this.$http.delete(`/api/ceremonies/${this.ceremony_to_delete.id}`);

                    this.ceremony_to_delete = false;
                    this.load();
                } catch (exception) {
                    if (!exception.response || (exception.response && exception.response.status !== 401)) {
                        alert('Cannot delete ceremony');
                    }
                }

                this.loading = false;
            },

            async sendInvites() {
                this.loading = true;

                try {
                    await this.$http.post(`/api/ceremonies/${this.ceremony_to_send_invites.id}/invites`);

                    this.ceremony_to_send_invites = null;

                    this.$notify({
                        group: 'default',
                        title: this.$t('ceremony.invitations_sent_title'),
                        text: this.$t('ceremony.invitations_sent_title'),
                        type: 'success',
                        duration: 2500,
                        position: 'top center',
                    });
                } catch (exception) {
                    if (!exception.response || (exception.response && exception.response.status !== 401)) {
                        alert('Cannot send invites');
                    }
                }

                this.loading = false;
            },

            async sendInvitesDownload() {
                this.loading = true;

                try {
                    await this.$http.post(`/api/ceremonies/${this.ceremony_to_send_invite_downloads.id}/invite-downloads`);

                    this.ceremony_to_send_invite_downloads = null;

                    this.$notify({
                        group: 'default',
                        title: this.$t('ceremony.invitations_sent_title'),
                        text: this.$t('ceremony.invitations_sent_message'),
                        type: 'success',
                        duration: 2500,
                        position: 'top center',
                    });
                } catch (exception) {
                    if (!exception.response || (exception.response && exception.response.status !== 401)) {
                        alert('Cannot send invites');
                    }
                }

                this.loading = false;
            },

            editCeremony(ceremony) {
                this.ceremonyErrors = null;
                this.ceremonyToEdit = ceremony;
                this.ceremonyData = {
                    ...ceremony,
                };
            },

            toggleDeleteCeremonyModal(ceremony) {
                this.ceremony_to_delete = ceremony;
            },

            toggleSendInvitesModal(ceremony) {
                this.ceremony_to_send_invites = ceremony;
            },

            toggleSendInviteDownloadsModal(ceremony) {
                this.ceremony_to_send_invite_downloads = ceremony;
            },

            getStateBadgeClass(ceremony) {
                if (ceremony.cleaned_up_at) {
                    return 'badge-warning';
                }

                if (ceremony.state.id === 1) {
                    return 'badge-info';
                }

                if (ceremony.state.id === 2) {
                    return 'badge-success';
                }
            },

            getStateText(ceremony) {
                if (ceremony.cleaned_up_at) {
                    return this.$t('ceremony.cleaned_up');
                }

                return this.$t('ceremony.state_' + ceremony.state.state.capitalize());
            },

            getStateTooltip(ceremony) {
                if (ceremony.cleaned_up_at) {
                    return this.$t('ceremony.cleaned_up_message', {
                        type: ceremony.translated_type,
                    });
                }

                return null;
            },

            getCeremonyAttendeeEmails(ceremonee) {
                return ceremonee.attendees.map(attendee => attendee.email);
            },

            createCeremony() {
                this.ceremonyErrors = null;
                this.ceremonyData = {
                    id: null,
                    name: '',
                    type: 'ceremony',
                    date_unknown: false,
                    date: '',
                    duration: null,
                    location_id: this.locations.length === 1 ? this.locations[0].id : null,
                    state_id: 1,
                    attendees: [
                        {
                            name: '',
                            email: '',
                        },
                    ],
                };
            },

            canSendInvite(ceremony) {
                if (window.IS_LOCAL) {
                    return false;
                }

                return !ceremony.cleaned_up_at && ceremony.state_id === 1 /*1 = open*/ && moment().isSameOrBefore(moment(ceremony.date));
            },

            canSendInviteDownload(ceremony) {
                if (window.IS_LOCAL) {
                    return false;
                }

                return !ceremony.cleaned_up_at && ceremony.state_id === 2 /*2 = ingediend*/;
            },
        },
    };

</script>
